import script from "./HelpRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpRequest.vue?vue&type=script&setup=true&lang=js"

import "./HelpRequest.vue?vue&type=style&index=0&id=922e3f56&lang=css"
import "./HelpRequest.vue?vue&type=style&index=1&id=922e3f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922e3f56"]])

export default __exports__